import { render, staticRenderFns } from "./SettingContentWrapper.vue?vue&type=template&id=107c9b00&"
import script from "./SettingContentWrapper.vue?vue&type=script&lang=ts&"
export * from "./SettingContentWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SettingContentWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports